import { useEffect, useState } from "react";
import useIsMobile from "@hooks/useIsMobile";
var map = {
  mobile: '(max-width: 480px)',
  tablet: '(min-width: 481px) and (max-width: 1024px)',
  desktop_small: '(min-width: 1025px) and (max-width: 1500px)',
  desktop_large: '(min-width: 1501px)'
};
var getSize = function getSize() {
  if (__IS_SSR__) {
    return 'N.A';
  }
  if (window.matchMedia(map.mobile).matches) {
    return 'mobile';
  } else if (window.matchMedia(map.tablet).matches) {
    return 'tablet';
  }
  if (window.matchMedia(map.desktop_small).matches) {
    return 'desktop_small';
  }
  return 'desktop_large';
};
var useDetectDeviceByMediaQuery = function useDetectDeviceByMediaQuery() {
  var _useState = useState(getSize()),
    device = _useState[0],
    setDevice = _useState[1];
  var isMobile = useIsMobile();
  useEffect(function () {
    var handleResize = function handleResize() {
      setDevice(getSize);
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  if (__IS_SSR__) {
    return isMobile ? 'mobile' : 'desktop_large';
  }
  return device;
};
export default useDetectDeviceByMediaQuery;